import React, { useState } from 'react';
import { Layout, theme } from 'antd';
import { useAppSelector } from '../../store';
import { useEmeraldTheme } from '../../theme/EmeraldThemeProvider';
import GlobalHeader from './GlobalHeader';
import SideNavigation from './SideNavigation';
import NotificationCenter from './NotificationCenter';
import StageTransitionManager from '../transitions/StageTransitionManager';
import '../../theme/emeraldStyles.css';

const { Content, Sider } = Layout;

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const { currentStage } = useAppSelector(state => state.stage);
  const { profile: company } = useAppSelector(state => state.company);
  const { isDark } = useEmeraldTheme();

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  return (
    <Layout
      style={{
        minHeight: '100vh',
        background: 'transparent',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* 现代化顶部导航 */}
      <GlobalHeader
        stage={currentStage}
        company={company}
        collapsed={collapsed}
        setCollapsed={setCollapsed}
      />

      <Layout hasSider>
        {/* 优雅毛玻璃侧边栏 - 固定定位 */}
        <Sider
          width={280}
          collapsedWidth={80}
          collapsed={collapsed}
          theme="light"
          className="emerald-sider"
          style={{
            overflow: 'auto',
            height: 'calc(100vh - 64px)',
            position: 'fixed',
            top: 64,
            left: 0,
            zIndex: 100,
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          }}
        >
          <SideNavigation stage={currentStage} collapsed={collapsed} />
        </Sider>

        {/* 主内容区域 - 添加左边距适应固定侧边栏 */}
        <Layout
          style={{
            background: 'transparent',
            marginLeft: collapsed ? 80 : 280,
            transition: 'margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          }}
        >
          <Content
            className="emerald-content"
            style={{
              minHeight: 'calc(100vh - 112px)',
              overflow: 'hidden',
              position: 'relative',
            }}
          >
            <div
              style={{
                padding: '0',
                height: '100%',
                background: 'transparent',
                position: 'relative',
                zIndex: 1,
              }}
            >
              {children}
            </div>
          </Content>
        </Layout>
      </Layout>

      {/* 全局组件 */}
      <NotificationCenter />
      <StageTransitionManager />
    </Layout>
  );
};

export default MainLayout;
